import React,{Component} from 'react';
import {Row,Col} from 'reactstrap';

class HelpContactInfo extends Component {
  render(){
    return (
      <div>
        <Row>
          <Col xs='12'>
            <p>
              There are several ways you can reach out to us for more information. Whichever option you choose, we will review and respond to your inquiry as soon as possible.
            </p>
            <ol>
              <li>
                <strong>Message Us</strong> - via Help Chat<br />
                <p>
                  While logged into the ad manager, click on the Help Chat on the bottom right to message us and get answers in real time.<br />
                  <i>Available during office hours: 9am – 5pm EST Monday through Friday</i>
                </p>
              </li>
              <li>
                <strong>Email Us </strong><br />
                <p>
                  If you prefer email communication or if you have a question after office hours, email us at <a href='mailto:campaignhelp@downtimedollars.com'>campaignhelp@downtimedollars.com</a>.
                </p>
              </li>
              <li>
                <strong>Call Us</strong><br />
                <p>
                  Speak with us toll free at <strong>855.620.4220</strong><br />
                  <i>Available during office hours: 9am – 5pm EST Monday through Friday, or leave a message anytime</i>
                </p>
              </li>
            </ol>
          </Col>
        </Row>
      </div>
    )
  }
}

export default HelpContactInfo;



// WEBPACK FOOTER //
// ./src/routes/HelpContactInfo/components/HelpContactInfo.js